import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType,
  WorkflowComponentParameterMode
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class QuadbinFromPoint extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.quadbinfrompoint',
        group: 'Spatial Indexes',
        title: 'Quadbin from GeoPoint',
        description: `
      This component adds a new column containing the indices of Quadbin cells corresponding to points.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'pointscol',
          type: WorkflowComponentParamType.Column,
          title: 'Points column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'resolution',
          type: WorkflowComponentParamType.Number,
          title: 'Resolution',
          min: 0,
          max: 26,
          default: 12,
          mode: WorkflowComponentParameterMode.Slider
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return `SELECT /*+ REPARTITION(40) */
              QUADBIN_FROMGEOGPOINT(
                ST_ASTEXT(${connection.processInputGeogColumn(params.pointscol as string)}),
                CAST(${params.resolution} AS INTEGER)
              ) quadbin, *
              FROM ${connection.quoteName(params.source as string)}`
    } else {
      return `SELECT
              ${connection.quoteName(envVars.analyticsToolboxDataset as string)}.QUADBIN_FROMGEOGPOINT(
                ${params.pointscol},
                CAST(${params.resolution} AS INTEGER)
              ) quadbin, *
              FROM ${connection.quoteName(params.source as string)}`
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    return '1.0.0'
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: 'quadbin',
      type: ColumnDataType.Number
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { QuadbinFromPoint }
